<template>
  <v-dialog
    v-model="showModal"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-calendar-clock
        </v-icon> Filter Activities
      </h2>
      <v-form>
        <v-card-text class="text-body-1 text-center">
          <v-container fluid>
            <v-dialog
              ref="fromDialog"
              v-model="fromCalendar"
              :return-value.sync="fromDate"
              width="290px"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="fromDate"
                  label="From"
                  outlined
                  filled
                  color="#000000"
                  dense
                  light
                  prepend-icon="mdi-calendar-month-outline"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-if="fromCalendar"
                v-model="fromDate"
                full-width
                color="#37474F"
                light
                :max="maxStartDate"
              >
                <v-spacer />
                <v-btn
                  text
                  color="#37474F"
                  @click="fromCalendar = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="#37474F"
                  @click="$refs.fromDialog.save(fromDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="toDialog"
              v-model="toCalendar"
              :return-value.sync="toDate"
              width="290px"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="toDate"
                  label="To"
                  outlined
                  filled
                  prepend-icon="mdi-calendar-month-outline"
                  color="#000000"
                  dense
                  light
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-if="toCalendar"
                v-model="toDate"
                full-width
                color="#37474F"
                light
                :min="minEndDate"
                :max="maxStartDate"
              >
                <v-spacer />
                <v-btn
                  text
                  color="#37474F"
                  @click="toCalendar = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="#37474F"
                  @click="$refs.toDialog.save(toDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <v-card-actions>
              <v-spacer />
              <v-btn
                class="mt-2"
                color="#37474F"
                @click="showModal = false"
              >
                Cancel
              </v-btn>
              <v-btn
                class="mt-2"
                color="#FF3700"
                @click="filterActivities()"
              >
                Filter
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
import Constants from 'src/constants';
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';

export default {
  name: 'FilterUserActivities',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      showModal: true,
      fromDate: null,
      fromCalendar: false,
      toDate: null,
      toCalendar: false,
      loading: false,
      maxStartDate: moment().format('YYYY-MM-DD'),
    };
  },
  computed: {
    minEndDate () {
        return moment(this.fromDate).format('YYYY-MM-DD');
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    convertToGmt (date) {
        return moment(date).utc();
    },
    filterActivities () {
      if (this.fromDate === '') {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please select from and to dates before proceeding.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.$store.dispatch('userprofile/fetchFilteredActivities', {
        params: {
            checkInTime: this.fromDate,
            checkOutTime: this.toDate,
        },
      }).then(response => {
        this.loading = false;
        this.showModal = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-p-style {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
  padding-bottom: 10px;
}
.otp-style {
  margin: auto;
}
.fail-message-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
</style>
